export enum ComponentEnum {
    HOTSPOTS = "3DStage",
    HOSTPOSTS360 = "360Hotspots",
    HOTSPOTS_NAME = "Hotspots Name",
    OUT_LINK = "out_link"
}
